import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IconSvgWrap',
  props: {
    size: { default: 16 }
  },
  setup(__props: any) {

const props = __props as { size: number };


const svgWrapStyle = computed(() => {
  return {
    width: `${props.size}px`,
    height: `${props.size}px`,
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "svg-wrap",
    style: _normalizeStyle(_unref(svgWrapStyle))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})